<template>
  <ya-site-resource-list resource="rate" />
</template>

<script>
import YaSiteResourceList from './resourceList'

export default {
  name: 'YaSiteRoomRateList',
  components: { YaSiteResourceList },
}
</script>
